import React, { useState, useEffect, useRef } from 'react';
import AppSpinner from "../Spinner/AppSpinner";
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import { BASE_URL } from '../../constants';
import { apiFetch } from "../../utils/apiFetch";
import { useApiError } from '../../utils/useApiError';
import ValidationErrorModal from '../ValidationErrorModal/ValidationErrorModal';

// ---- STİLLƏR ----
const inputStyle = {
  width: '100%', border: '1px solid #e5e7eb',
  borderRadius: 5, padding: '7px 10px',
  fontSize: 13, color: '#111827', background: '#fff',
  outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit'
};

const labelStyle = {
  display: 'block', fontSize: 10, fontWeight: 700,
  color: '#6b7280', textTransform: 'uppercase',
  letterSpacing: '0.04em', marginBottom: 3
};

let _qKey = 0;

// Yeni sual yaradarkən default 4 variant olsun
const emptyQuestion = () => ({
  id: 0,
  _key: ++_qKey,
  question: '',
  level: 1,
  imageUuidName: '',
  _imagePreview: '',
  _imageUploading: false,
  answers: [
    { id: 0, answer: '', correct: true },
    { id: 0, answer: '', correct: false },
    { id: 0, answer: '', correct: false },
    { id: 0, answer: '', correct: false },
  ]
});

// Yeni test əlavə edərkən default 5 sual olsun
const getInitialQuestions = () => [emptyQuestion()];

const LevelButtons = ({ value, onChange }) => (
  <div style={{ display: 'flex', gap: 3 }}>
    {[
      { value: 1, label: 'Asan',  bg: '#f0fdf4', color: '#15803d', border: '#86efac' },
      { value: 2, label: 'Orta',  bg: '#fffbeb', color: '#b45309', border: '#fcd34d' },
      { value: 3, label: 'Çətin', bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
    ].map(lvl => (
      <button
        key={lvl.value}
        type="button"
        onClick={() => onChange(lvl.value)}
        style={{
          padding: '2px 7px', borderRadius: 4, fontSize: 10, fontWeight: 700,
          cursor: 'pointer', transition: 'all 0.15s',
          background: value === lvl.value ? lvl.bg : '#f3f4f6',
          color: value === lvl.value ? lvl.color : '#9ca3af',
          border: `1px solid ${value === lvl.value ? lvl.border : '#e5e7eb'}`,
        }}
      >
        {lvl.label}
      </button>
    ))}
  </div>
);

const ImageUploadBox = ({ imagePreview, onUpload, onRemove, uploading, onZoom }) => {
  const inputRef = useRef();
  return (
    <div>
      <label style={{ ...labelStyle, marginBottom: 4 }}>
        Şəkil <span style={{ color: '#9ca3af', textTransform: 'none', fontWeight: 400 }}>(istəyə bağlı)</span>
      </label>
      <div
        onClick={() => !uploading && inputRef.current.click()}
        style={{
          width: 80, height: 80, borderRadius: 6,
          cursor: uploading ? 'not-allowed' : 'pointer',
          border: imagePreview ? '2px solid #22c55e' : '2px dashed #d1d5db',
          background: imagePreview ? '#000' : '#fafafa',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          overflow: 'visible', position: 'relative', flexShrink: 0,
          transition: 'border-color 0.15s'
        }}
      >
        {imagePreview ? (
          <img src={imagePreview} alt="preview" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 4, overflow: 'hidden' }} />
        ) : uploading ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
            <span style={{ fontSize: 9, color: '#6b7280' }}>Yüklənir...</span>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
            <svg viewBox="0 0 24 24" fill="none" style={{ width: 28, height: 28 }}>
              <rect x="3" y="3" width="18" height="18" rx="3" stroke="#d1d5db" strokeWidth="1.5"/>
              <circle cx="8.5" cy="8.5" r="1.5" fill="#d1d5db"/>
              <path d="M3 15l5-5 4 4 3-3 6 6" stroke="#d1d5db" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 8v6M9 11h6" stroke="#9ca3af" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
            <span style={{ fontSize: 9, color: '#9ca3af', fontWeight: 600 }}>+ Şəkil</span>
          </div>
        )}
        {imagePreview && !uploading && (
          <>
            <div
              style={{
                position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.4)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                opacity: 0, transition: 'opacity 0.15s', borderRadius: 4
              }}
              onMouseEnter={e => e.currentTarget.style.opacity = 1}
              onMouseLeave={e => e.currentTarget.style.opacity = 0}
            >
              <span style={{ fontSize: 9, color: '#fff', fontWeight: 700 }}>Dəyiş</span>
            </div>
            <button
              onClick={e => { e.stopPropagation(); onRemove(); }}
              title="Şəkli sil"
              style={{
                position: 'absolute', top: -8, right: -8,
                width: 18, height: 18,
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                background: '#fef2f2', border: '1px solid #fecaca',
                borderRadius: 4, cursor: 'pointer', padding: 0, zIndex: 10
              }}
            >
              <svg viewBox="0 0 20 20" fill="none" style={{ width: 9, height: 9 }}>
                <path d="M4 10h12" stroke="#dc2626" strokeWidth="1.8" strokeLinecap="round"/>
              </svg>
            </button>
            <button
              onClick={e => { e.stopPropagation(); if (onZoom) onZoom(imagePreview); }}
              title="Şəkli böyüt"
              style={{
                position: 'absolute', bottom: -8, right: -8,
                width: 18, height: 18,
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                background: '#eff6ff', border: '1px solid #bfdbfe',
                borderRadius: 4, cursor: 'pointer', padding: 0, zIndex: 10
              }}
            >
              <svg viewBox="0 0 20 20" fill="none" style={{ width: 10, height: 10 }}>
                <path d="M1 10s3.5-6 9-6 9 6 9 6-3.5 6-9 6-9-6-9-6Z" stroke="#3b82f6" strokeWidth="1.6"/>
                <circle cx="10" cy="10" r="2.2" stroke="#3b82f6" strokeWidth="1.6"/>
              </svg>
            </button>
          </>
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={e => { const f = e.target.files[0]; if (f) onUpload(f); e.target.value = ''; }}
      />
    </div>
  );
};

const QuestionBlock = ({ q, qi, totalQuestions, onUpdate, onUpdateAnswer, onAddAnswer, onRemoveAnswer, onRemoveQuestion, onImageUpload, onImageRemove, onImageZoom, accentColor, borderColor }) => {
  return (
    <div style={{ background: '#fff', border: `1px solid ${borderColor}`, borderRadius: 6, padding: '8px 10px', marginBottom: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <span style={{ fontSize: 10, fontWeight: 700, color: '#374151' }}>{qi + 1}-ci sual</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ fontSize: 10, color: '#6b7280' }}>Səviyyə:</span>
          <LevelButtons value={q.level || 1} onChange={v => onUpdate(qi, 'level', v)} />
          <button
            onClick={() => onRemoveQuestion(qi)}
            style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 4, padding: '2px 6px', fontSize: 10, color: '#dc2626', cursor: 'pointer' }}
          >
            Sil
          </button>
        </div>
      </div>
      <textarea
        value={q.question}
        onChange={e => onUpdate(qi, 'question', e.target.value)}
        placeholder="Sual mətni"
        rows={3}
        style={{ ...inputStyle, marginBottom: 8, minHeight: 72, resize: 'vertical', lineHeight: 1.4 }}
      />
      <ImageUploadBox
        imagePreview={q._imagePreview}
        uploading={q._imageUploading}
        onUpload={(file) => onImageUpload(qi, file)}
        onRemove={() => onImageRemove(qi)}
        onZoom={onImageZoom}
      />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 6 }}>
        {q.answers.map((a, ai) => (
          <div key={ai} style={{ display: 'flex', alignItems: 'flex-start', gap: 5 }}>
            <input
              type="radio"
              name={`correct-${accentColor}-${qi}`}
              checked={a.correct}
              onChange={() => onUpdateAnswer(qi, ai, 'correct', true)}
              title="Düzgün cavab"
              style={{ cursor: 'pointer', accentColor: '#22c55e', flexShrink: 0, width: 16, height: 16, marginTop: 8 }}
            />
            <textarea
              value={a.answer}
              onChange={e => onUpdateAnswer(qi, ai, 'answer', e.target.value)}
              placeholder={`Cavab ${ai + 1}`}
              rows={2}
              style={{ ...inputStyle, flex: 1, fontSize: 13, padding: '7px 10px', minHeight: 56, resize: 'vertical', lineHeight: 1.35 }}
            />
            <button
              onClick={() => onRemoveAnswer(qi, ai)}
              style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 4, width: 20, height: 20, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0, padding: 0, marginTop: 8 }}
            >
              <svg viewBox="0 0 20 20" fill="none" style={{ width: 9, height: 9 }}>
                <path d="M4 10h12" stroke="#dc2626" strokeWidth="1.8" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
        ))}
        {/* Cavab sayı maksimum 7 ola bilər */}
        {q.answers.length < 7 ? (
          <button
            onClick={() => onAddAnswer(qi)}
            style={{ alignSelf: 'flex-start', background: 'transparent', border: '1px dashed #86efac', borderRadius: 4, padding: '2px 8px', fontSize: 10, color: '#15803d', cursor: 'pointer', marginTop: 2 }}
          >
            + Cavab əlavə et
          </button>
        ) : (
          <span style={{ fontSize: 9, color: '#9ca3af', marginTop: 2 }}>Maksimum 7 cavab</span>
        )}
      </div>
    </div>
  );
};

const LectureTests = ({ lectureId, initialTests = [], onRefresh, onShowToast }) => {
  const [tests, setTests] = useState(initialTests);
  const [selectedTest, setSelectedTest] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [cancelTarget, setCancelTarget] = useState(null); 
  const [txtLoading, setTxtLoading] = useState(false);
  const [zipLoading, setZipLoading] = useState(false);
  const txtInputRef = useRef(null);
  const zipInputRef = useRef(null);

  const [showAddPanel, setShowAddPanel] = useState(false);
  const [addForm, setAddForm] = useState({ name: '', description: '', sector: '', timeLimit: 5, questions: getInitialQuestions() });
  const [addLoading, setAddLoading] = useState(false);
  const [addError, setAddError] = useState('');
  const { errorModal, clearError, handleApiError } = useApiError();

  const [showEditPanel, setShowEditPanel] = useState(false);
  const [editForm, setEditForm] = useState({ name: '', description: '', sector: '', timeLimit: 10, questions: [] });
  const [editLoading, setEditLoading] = useState(false);
  const [editError, setEditError] = useState('');
  const [imageModalSrc, setImageModalSrc] = useState(null);

  useEffect(() => {
    setTests(initialTests);
    setSelectedTest(null);
  }, [initialTests]);

  const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiFetch(`${BASE_URL}/files/upload-quiz-question-image`, {
      method: 'POST',
      body: formData
    });
    if (!response.ok) throw new Error('Şəkil yüklənərkən xəta');
    const data = await response.json();
    return data.fileUuidName || data.fileEntity?.fileUuidName || '';
  };

  const handleAddImageUpload = (qi, file) => {
    const previewUrl = URL.createObjectURL(file);
    setAddForm(p => { const qs = [...p.questions]; qs[qi] = { ...qs[qi], _imageFile: file, _imagePreview: previewUrl }; return { ...p, questions: qs }; });
  };

  const handleEditImageUpload = (qi, file) => {
    const previewUrl = URL.createObjectURL(file);
    setEditForm(p => { const qs = [...p.questions]; qs[qi] = { ...qs[qi], _imageFile: file, _imagePreview: previewUrl }; return { ...p, questions: qs }; });
  };

  const handleAddImageRemove = (qi) => {
    setAddForm(p => { const qs = [...p.questions]; qs[qi] = { ...qs[qi], _imageFile: null, _imagePreview: '', imageUuidName: '' }; return { ...p, questions: qs }; });
  };

  const handleEditImageRemove = (qi) => {
    setEditForm(p => { const qs = [...p.questions]; qs[qi] = { ...qs[qi], _imageFile: null, _imagePreview: '', imageUuidName: '' }; return { ...p, questions: qs }; });
  };

  const handleZipUpload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setZipLoading(true);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await apiFetch(`${BASE_URL}/quizzes/lecture/${lectureId}/from-txt/v2`, {
        method: 'POST',
        body: formData,
      });
      if (!res.ok) {
        let msg = 'ZIP fayl yüklənərkən xəta baş verdi.';
        try { const d = await res.json(); msg = d.message || d.error || msg; } catch (_) {}
        throw new Error(msg);
      }
      if (onRefresh) onRefresh();
      onShowToast('Test ZIP-dən uğurla yükləndi.', 'success');
    } catch (err) {
      handleApiError({ message: err.message || 'ZIP fayl yüklənərkən xəta baş verdi.' });
    } finally {
      setZipLoading(false);
    }
  };

  const handleTxtUpload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setTxtLoading(true);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await apiFetch(`${BASE_URL}/quizzes/lecture/${lectureId}/from-txt`, {
        method: 'POST',
        body: formData,
      });
      if (!res.ok) {
        let msg = 'Fayl yüklənərkən xəta baş verdi.';
        try { const d = await res.json(); msg = d.message || d.error || msg; } catch (_) {}
        throw new Error(msg);
      }
      if (onRefresh) onRefresh();
      onShowToast('Test uğurla yükləndi.', 'success');
    } catch (err) {
      handleApiError({ message: err.message || 'Fayl yüklənərkən xəta baş verdi.' });
    } finally {
      setTxtLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      const res = await apiFetch(`${BASE_URL}/quizzes/${selectedTest.id}`, {
        method: 'DELETE',
      });
      if (!res.ok) throw new Error('Silinərkən xəta baş verdi.');
      setTests(prev => prev.filter(t => t.id !== selectedTest.id));
      setSelectedTest(null);
      setShowDeleteConfirm(false);
      onShowToast('Test uğurla silindi.', 'success');
    } catch (err) {
      setShowDeleteConfirm(false);
    }
  };

  const handleAdd = async () => {
    if (!addForm.name.trim()) { setAddError('Test adı mütləqdir.'); return; }
    
    // VALIDASIYA: Minimum 5 sual
    if (addForm.questions.length < 5) {
      setAddError('Testdə ən azı 5 sual olmalıdır.');
      return;
    }

    for (let i = 0; i < addForm.questions.length; i++) {
      if (!addForm.questions[i].question.trim()) { setAddError(`${i + 1}-ci sualın mətni boşdur.`); return; }
      // VALIDASIYA: 4-7 variant arası
      if (addForm.questions[i].answers.length < 4) { setAddError(`${i + 1}-ci sualda ən azı 4 cavab variantı olmalıdır.`); return; }
      if (addForm.questions[i].answers.length > 7) { setAddError(`${i + 1}-ci sualda maksimum 7 cavab variantı ola bilər.`); return; }
      if (!addForm.questions[i].answers.some(a => a.correct)) { setAddError(`${i + 1}-ci sualda düzgün cavab seçilməyib.`); return; }
    }

    setAddLoading(true);
    setAddError('');
    try {
      const addQuestionsWithImages = await Promise.all(addForm.questions.map(async q => {
        let imageUuidName = q.imageUuidName || '';
        if (q._imageFile) {
          try { imageUuidName = await uploadImage(q._imageFile); } catch (_) {}
        }
        return { id: 0, question: q.question, level: q.level || 0, imageUuidName, answers: q.answers.map(a => ({ id: 0, answer: a.answer, correct: a.correct })) };
      }));
      const response = await apiFetch(`${BASE_URL}/quizzes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: addForm.name,
          description: addForm.description || '',
          sector: addForm.sector || '',
          timeLimit: Number(addForm.timeLimit),
          lectureId: Number(lectureId),
          questions: addQuestionsWithImages
        })
      });
      if (!response.ok) {
        let msg = 'Əlavə edilərkən xəta baş verdi.';
        try { const d = await response.json(); msg = d.message || d.error || msg; } catch (_) {}
        throw new Error(msg);
      }
      let newTest = null;
      try { const data = await response.json(); newTest = data?.quiz ?? data; } catch (_) {}
      if (newTest) setTests(prev => [...prev, newTest]);
      setAddForm({ name: '', description: '', sector: '', timeLimit: 10, questions: getInitialQuestions() });
      setShowAddPanel(false);
      onShowToast('Test uğurla əlavə edildi.', 'success');
    } catch (err) {
      handleApiError({ message: err.message || 'Əlavə edilərkən xəta baş verdi.' });
    } finally {
      setAddLoading(false);
    }
  };

  const fetchEditQuestionImages = (questions) => {
    const token = localStorage.getItem('teacher_authToken');
    questions.forEach((qs, qi) => {
      if (!qs.imageUuidName) return;
      fetch(`${BASE_URL}/files/download-quiz-question-image/${qs.imageUuidName}`, {
        headers: { Authorization: `Basic ${token}` }
      }).then(res => {
        if (!res.ok) return;
        return res.blob();
      }).then(blob => {
        if (!blob) return;
        const url = URL.createObjectURL(blob);
        setEditForm(p => {
          const updated = [...p.questions];
          if (updated[qi]) updated[qi] = { ...updated[qi], _imagePreview: url };
          return { ...p, questions: updated };
        });
      }).catch(() => {});
    });
  };

  const handleOpenEdit = () => {
    if (!selectedTest) return;
    setShowAddPanel(false);
    setEditError('');
    const questions = (selectedTest.questions || []).map(qs => ({
      id: qs.id || 0,
      question: qs.question || '',
      level: qs.level || 1,
      imageUuidName: qs.imageUuidName || '',
      _key: qs.id || Math.random(),
      _imagePreview: '',
      _imageFile: null,
      _imageUploading: false,
      answers: (qs.answers || []).map(a => ({
        id: a.id || 0,
        answer: a.answer || '',
        correct: a.correct || false
      }))
    }));
    setEditForm({
      id: selectedTest.id,
      name: selectedTest.name || '',
      description: selectedTest.description || '',
      sector: selectedTest.sector || '',
      timeLimit: selectedTest.timeLimit || 10,
      questions
    });
    setShowEditPanel(true);
    fetchEditQuestionImages(selectedTest.questions || []);
  };

  const handleEdit = async () => {
    if (!editForm.name.trim()) { setEditError('Test adı mütləqdir.'); return; }
    
    // VALIDASIYA: Minimum 5 sual
    if (editForm.questions.length < 5) {
      setEditError('Testdə ən azı 5 sual olmalıdır.');
      return;
    }

    for (let i = 0; i < editForm.questions.length; i++) {
      if (!editForm.questions[i].question.trim()) { setEditError(`${i + 1}-ci sualın mətni boşdur.`); return; }
      // VALIDASIYA: 4-7 variant arası
      if (editForm.questions[i].answers.length < 4) { setEditError(`${i + 1}-ci sualda ən azı 4 cavab variantı olmalıdır.`); return; }
      if (editForm.questions[i].answers.length > 7) { setEditError(`${i + 1}-ci sualda maksimum 7 cavab variantı ola bilər.`); return; }
      if (!editForm.questions[i].answers.some(a => a.correct)) { setEditError(`${i + 1}-ci sualda düzgün cavab seçilməyib.`); return; }
    }

    setEditLoading(true);
    setEditError('');
    try {
      const editQuestionsWithImages = await Promise.all(editForm.questions.map(async q => {
        let imageUuidName = q.imageUuidName || '';
        if (q._imageFile) {
          try { imageUuidName = await uploadImage(q._imageFile); } catch (_) {}
        }
        const safeId = (q.id && q.id <= 2147483647) ? q.id : 0;
        const safeAnswers = q.answers.map(a => ({ id: (a.id && a.id <= 2147483647) ? a.id : 0, answer: a.answer, correct: a.correct }));
        return { id: safeId, question: q.question, level: q.level || 0, imageUuidName, answers: safeAnswers };
      }));
      const body = {
        id: editForm.id,
        name: editForm.name,
        description: editForm.description || '',
        sector: editForm.sector || '',
        timeLimit: Number(editForm.timeLimit),
        lectureId: Number(lectureId),
        questions: editQuestionsWithImages
      };
      const response = await apiFetch(`${BASE_URL}/quizzes`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!response.ok) {
        let msg = 'Redaktə edilərkən xəta baş verdi.';
        try { const d = await response.json(); msg = d.message || d.error || msg; } catch (_) {}
        throw new Error(msg);
      }
      const updatedLocal = {
        ...selectedTest,
        name: editForm.name,
        description: editForm.description,
        sector: editForm.sector,
        questions: editQuestionsWithImages.map((q, i) => ({
          id: q.id || 0,
          question: q.question,
          level: q.level,
          imageUuidName: q.imageUuidName || '',
          answers: q.answers
        }))
      };
      setTests(prev => prev.map(t => t.id === editForm.id ? updatedLocal : t));
      setSelectedTest(null);
      setShowEditPanel(false);
      onShowToast('Test uğurla redaktə olundu.', 'success');
    } catch (err) {
      handleApiError({ message: err.message || 'Redaktə edilərkən xəta baş verdi.' });
    } finally {
      setEditLoading(false);
    }
  };

  // ---- ADD HELPERS ----
  const updateAddQuestion = (qi, field, value) => setAddForm(p => { const qs = [...p.questions]; qs[qi] = { ...qs[qi], [field]: value }; return { ...p, questions: qs }; });
  const updateAddAnswer = (qi, ai, field, value) => setAddForm(p => { const qs = [...p.questions]; const answers = [...qs[qi].answers]; if (field === 'correct' && value === true) { answers.forEach((a, i) => answers[i] = { ...a, correct: i === ai }); } else { answers[ai] = { ...answers[ai], [field]: value }; } qs[qi] = { ...qs[qi], answers }; return { ...p, questions: qs }; });
  const addAddAnswer = (qi) => setAddForm(p => { const qs = [...p.questions]; if (qs[qi].answers.length >= 7) return p; qs[qi] = { ...qs[qi], answers: [...qs[qi].answers, { id: 0, answer: '', correct: false }] }; return { ...p, questions: qs }; });
  const removeAddAnswer = (qi, ai) => setAddForm(p => { const qs = [...p.questions]; qs[qi] = { ...qs[qi], answers: qs[qi].answers.filter((_, i) => i !== ai) }; return { ...p, questions: qs }; });
  const addAddQuestion = () => setAddForm(p => ({ ...p, questions: [...p.questions, emptyQuestion()] }));
  const removeAddQuestion = (qi) => setAddForm(p => ({ ...p, questions: p.questions.filter((_, i) => i !== qi) }));

  // ---- EDIT HELPERS ----
  const updateEditQuestion = (qi, field, value) => setEditForm(p => { const qs = [...p.questions]; qs[qi] = { ...qs[qi], [field]: value }; return { ...p, questions: qs }; });
  const updateEditAnswer = (qi, ai, field, value) => setEditForm(p => { const qs = [...p.questions]; const answers = [...qs[qi].answers]; if (field === 'correct' && value === true) { answers.forEach((a, i) => answers[i] = { ...a, correct: i === ai }); } else { answers[ai] = { ...answers[ai], [field]: value }; } qs[qi] = { ...qs[qi], answers }; return { ...p, questions: qs }; });
  const addEditAnswer = (qi) => setEditForm(p => { const qs = [...p.questions]; if (qs[qi].answers.length >= 7) return p; qs[qi] = { ...qs[qi], answers: [...qs[qi].answers, { id: 0, answer: '', correct: false }] }; return { ...p, questions: qs }; });
  const removeEditAnswer = (qi, ai) => setEditForm(p => { const qs = [...p.questions]; qs[qi] = { ...qs[qi], answers: qs[qi].answers.filter((_, i) => i !== ai) }; return { ...p, questions: qs }; });
  const addEditQuestion = () => setEditForm(p => ({ ...p, questions: [...p.questions, emptyQuestion()] }));
  const removeEditQuestion = (qi) => setEditForm(p => ({ ...p, questions: p.questions.filter((_, i) => i !== qi) }));

  const handleCancelAdd = () => { setCancelTarget('add'); setShowCancelConfirm(true); };
  const handleCancelEdit = () => { setCancelTarget('edit'); setShowCancelConfirm(true); };
  const confirmCancel = () => {
    if (cancelTarget === 'add') { setShowAddPanel(false); setAddForm({ name: '', description: '', sector: '', questions: getInitialQuestions() }); setAddError(''); }
    if (cancelTarget === 'edit') { setShowEditPanel(false); setEditForm({ name: '', description: '', sector: '', questions: [] }); setEditError(''); }
    setShowCancelConfirm(false);
    setCancelTarget(null);
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>

        {/* ---- BAŞLIQ ---- */}
        <div style={{ background: '#f3f4f6', borderBottom: '1px solid #e5e7eb', padding: '8px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ fontWeight: 700, fontSize: 11, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Testlər</span>
            {tests.length > 0 && (
              <span style={{ background: '#e0e7ff', color: '#4338ca', padding: '1px 7px', borderRadius: 10, fontSize: 10, fontWeight: 700 }}>{tests.length}</span>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            {!showAddPanel && !showEditPanel && <>
              <button disabled={!selectedTest} onClick={handleOpenEdit} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: selectedTest ? '#3b82f6' : '#bfdbfe', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', fontWeight: 600, fontSize: 11, cursor: selectedTest ? 'pointer' : 'not-allowed' }}>Redaktə et</button>
              <button disabled={!selectedTest} onClick={() => setShowDeleteConfirm(true)} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: selectedTest ? '#ef4444' : '#fecaca', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', fontWeight: 600, fontSize: 11, cursor: selectedTest ? 'pointer' : 'not-allowed' }}>Sil</button>
              <input ref={txtInputRef} type="file" accept=".txt" style={{ display: 'none' }} onChange={handleTxtUpload} />
              <button disabled={txtLoading} onClick={() => txtInputRef.current?.click()} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, justifyContent: 'center', background: txtLoading ? '#a5b4fc' : '#6366f1', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', fontWeight: 600, fontSize: 11, cursor: txtLoading ? 'not-allowed' : 'pointer' }}>
                {txtLoading ? <><AppSpinner inline />Yüklənir...</> : <><i className="bi bi-upload" style={{ fontSize: 11 }}></i> Test yüklə</>}
              </button>
              <input ref={zipInputRef} type="file" accept=".zip" style={{ display: 'none' }} onChange={handleZipUpload} />
              <button disabled={zipLoading} onClick={() => zipInputRef.current?.click()} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, justifyContent: 'center', background: zipLoading ? '#fdba74' : '#f97316', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', fontWeight: 600, fontSize: 11, cursor: zipLoading ? 'not-allowed' : 'pointer' }}>
                {zipLoading ? <><AppSpinner inline />Yüklənir...</> : <><i className="bi bi-file-earmark-zip" style={{ fontSize: 11 }}></i> Test yüklə ZIP</>}
              </button>
            </>}
            {showAddPanel && (
              <>
                <button onClick={addAddQuestion} style={{ display: 'inline-flex', alignItems: 'center', gap: 3, background: '#dcfce7', color: '#15803d', border: '1px solid #86efac', borderRadius: 5, padding: '4px 10px', fontWeight: 600, fontSize: 11, cursor: 'pointer' }}>+ Sual əlavə et</button>
                <button onClick={handleCancelAdd} disabled={addLoading} style={{ background: '#fff', color: '#374151', border: '1px solid #d1d5db', borderRadius: 5, padding: '4px 12px', fontWeight: 600, fontSize: 11, cursor: 'pointer' }}>Ləğv et</button>
              </>
            )}
            {showEditPanel && (
              <>
                <button onClick={addEditQuestion} style={{ display: 'inline-flex', alignItems: 'center', gap: 3, background: '#dbeafe', color: '#1d4ed8', border: '1px solid #93c5fd', borderRadius: 5, padding: '4px 10px', fontWeight: 600, fontSize: 11, cursor: 'pointer' }}>+ Sual əlavə et</button>
                <button onClick={handleCancelEdit} disabled={editLoading} style={{ background: '#fff', color: '#374151', border: '1px solid #d1d5db', borderRadius: 5, padding: '4px 12px', fontWeight: 600, fontSize: 11, cursor: 'pointer' }}>Ləğv et</button>
              </>
            )}
            <button onClick={() => { setShowEditPanel(false); setShowAddPanel(p => !p); }} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: showAddPanel ? '#15803d' : '#22c55e', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', fontWeight: 600, fontSize: 11, cursor: 'pointer', transition: 'background 0.15s' }}>
              <svg viewBox="0 0 22 22" fill="white" xmlns="http://www.w3.org/2000/svg" style={{ width: 11, height: 11 }}>
                <path d="M11.75 8C11.75 7.586 11.414 7.25 11 7.25S10.25 7.586 10.25 8v2.25H8c-.414 0-.75.336-.75.75s.336.75.75.75h2.25V14c0 .414.336.75.75.75s.75-.336.75-.75v-2.25H14c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-2.25V8Z"/>
              </svg>
              {showAddPanel ? 'Bağla' : 'Yeni test'}
            </button>
          </div>
        </div>

        {/* ---- ƏLAVƏ ET PANELİ ---- */}
        <div style={{ overflowY: showAddPanel ? 'auto' : 'hidden', maxHeight: showAddPanel ? '78%' : 0, transition: 'max-height 0.3s ease', flexShrink: 0 }}>
          <div style={{ background: '#f0fdf4', borderBottom: '2px solid #22c55e', padding: '12px 12px 10px' }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#15803d', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.04em' }}>+ Yeni Test</div>
            <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
              <div style={{ flex: 2 }}>
                <label style={labelStyle}>Test adı <span style={{ color: '#ef4444' }}>*</span></label>
                <input value={addForm.name} onChange={e => { setAddForm(p => ({ ...p, name: e.target.value })); setAddError(''); }} placeholder="Test adı" style={{ ...inputStyle, borderColor: addError && !addForm.name.trim() ? '#ef4444' : '#e5e7eb' }} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Sektor</label>
                <select value={addForm.sector} onChange={e => setAddForm(p => ({ ...p, sector: e.target.value }))} style={inputStyle}>
                  <option value="">Seçin</option>
                  <option value="Az">AZ</option>
                  <option value="Rus">RUS</option>
                  <option value="Eng">ENG</option>
                </select>
              </div>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Vaxt limiti <span style={{ color: '#ef4444' }}>*</span></label>
                <input type="number" min="1" value={addForm.timeLimit} onChange={e => setAddForm(p => ({ ...p, timeLimit: Number(e.target.value) }))} style={inputStyle} />
              </div>
            </div>
            <div style={{ marginBottom: 10 }}>
              <label style={labelStyle}>Təsvir</label>
              <input value={addForm.description} onChange={e => setAddForm(p => ({ ...p, description: e.target.value }))} placeholder="Test haqqında qısa məlumat" style={inputStyle} />
            </div>
            <div style={{ borderTop: '1px solid #d1fae5', paddingTop: 10 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                <span style={{ fontSize: 10, fontWeight: 700, color: '#15803d', textTransform: 'uppercase' }}>Suallar</span>
              </div>
              {addForm.questions.map((q, qi) => (
                <QuestionBlock key={q._key || qi} q={q} qi={qi} totalQuestions={addForm.questions.length} onUpdate={updateAddQuestion} onUpdateAnswer={updateAddAnswer} onAddAnswer={addAddAnswer} onRemoveAnswer={removeAddAnswer} onRemoveQuestion={removeAddQuestion} onImageUpload={handleAddImageUpload} onImageRemove={handleAddImageRemove} onImageZoom={src => setImageModalSrc(src)} accentColor="add" borderColor="#d1fae5" />
              ))}
            </div>
            {addError && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 5, padding: '4px 10px', color: '#dc2626', fontSize: 11, marginBottom: 8 }}>{addError}</div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 6, marginTop: 8 }}>
              <button onClick={handleAdd} disabled={addLoading} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: addLoading ? '#86efac' : '#22c55e', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 14px', fontWeight: 600, fontSize: 11, cursor: addLoading ? 'not-allowed' : 'pointer' }}>
                {addLoading ? <><AppSpinner inline />Əlavə edilir...</> : 'Əlavə et'}
              </button>
            </div>
          </div>
        </div>

        {/* ---- REDAKTƏ PANELİ ---- */}
        <div style={{ overflowY: showEditPanel ? 'auto' : 'hidden', maxHeight: showEditPanel ? '78%' : 0, transition: 'max-height 0.3s ease', flexShrink: 0 }}>
          <div style={{ background: '#eff6ff', borderBottom: '2px solid #3b82f6', padding: '12px 12px 10px' }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#1d4ed8', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Redaktə — {selectedTest?.name}</div>
            <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
              <div style={{ flex: 2 }}>
                <label style={labelStyle}>Test adı <span style={{ color: '#ef4444' }}>*</span></label>
                <input value={editForm.name} onChange={e => { setEditForm(p => ({ ...p, name: e.target.value })); setEditError(''); }} placeholder="Test adı" style={{ ...inputStyle, borderColor: editError && !editForm.name.trim() ? '#ef4444' : '#e5e7eb' }} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Sektor</label>
                <select value={editForm.sector} onChange={e => setEditForm(p => ({ ...p, sector: e.target.value }))} style={inputStyle}>
                  <option value="">Seçin</option>
                  <option value="Az">AZ</option>
                  <option value="Rus">RUS</option>
                  <option value="Eng">ENG</option>
                </select>
              </div>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Vaxt limiti <span style={{ color: '#ef4444' }}>*</span></label>
                <input type="number" min="1" value={editForm.timeLimit} onChange={e => setEditForm(p => ({ ...p, timeLimit: Number(e.target.value) }))} style={inputStyle} />
              </div>
            </div>
            <div style={{ marginBottom: 10 }}>
              <label style={labelStyle}>Təsvir</label>
              <input value={editForm.description} onChange={e => setEditForm(p => ({ ...p, description: e.target.value }))} placeholder="Test haqqında qısa məlumat" style={inputStyle} />
            </div>
            <div style={{ borderTop: '1px solid #bfdbfe', paddingTop: 10 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                <span style={{ fontSize: 10, fontWeight: 700, color: '#1d4ed8', textTransform: 'uppercase' }}>
                  Suallar
                  <span style={{ marginLeft: 6, background: '#dbeafe', color: '#1d4ed8', padding: '1px 6px', borderRadius: 8, fontSize: 9 }}>{editForm.questions.length}</span>
                </span>
              </div>
              {editForm.questions.map((q, qi) => (
                <QuestionBlock key={q._key || qi} q={q} qi={qi} totalQuestions={editForm.questions.length} onUpdate={updateEditQuestion} onUpdateAnswer={updateEditAnswer} onAddAnswer={addEditAnswer} onRemoveAnswer={removeEditAnswer} onRemoveQuestion={removeEditQuestion} onImageUpload={handleEditImageUpload} onImageRemove={handleEditImageRemove} onImageZoom={src => setImageModalSrc(src)} accentColor="edit" borderColor="#bfdbfe" />
              ))}
            </div>
            {editError && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 5, padding: '4px 10px', color: '#dc2626', fontSize: 11, marginBottom: 8 }}>{editError}</div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 6, marginTop: 8 }}>
              <button onClick={handleEdit} disabled={editLoading} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: editLoading ? '#93c5fd' : '#3b82f6', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 14px', fontWeight: 600, fontSize: 11, cursor: editLoading ? 'not-allowed' : 'pointer' }}>
                {editLoading ? <><AppSpinner inline />Yadda saxlanılır...</> : 'Yadda saxla'}
              </button>
            </div>
          </div>
        </div>

        {/* ---- SİYAHI ---- */}
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {tests.length > 0 ? (
            tests.map((test, index) => {
              const isSelected = selectedTest?.id === test.id;
              return (
                <div
                  key={test.id}
                  onClick={(e) => { setSelectedTest(e.ctrlKey && isSelected ? null : test); setShowEditPanel(false); }}
                  style={{ display: 'flex', alignItems: 'center', padding: '7px 12px', borderBottom: '1px solid #f3f4f6', background: isSelected ? '#eff6ff' : '#fff', cursor: 'pointer', transition: 'background 0.12s' }}
                  onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = '#f9fafb'; }}
                  onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = '#fff'; }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, minWidth: 0 }}>
                    <span style={{ background: '#f3f4f6', color: '#6b7280', padding: '1px 6px', borderRadius: 3, fontSize: 10, fontWeight: 700, flexShrink: 0 }}>{index + 1}</span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 600, fontSize: 12, color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {test.name || test.title || `Test ${index + 1}`}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2 }}>
                        {test.sector && <span style={{ background: '#eff6ff', color: '#1d4ed8', padding: '0px 5px', borderRadius: 3, fontSize: 9, fontWeight: 600, border: '1px solid #bfdbfe' }}>{test.sector}</span>}
                        {test.register && <span style={{ fontSize: 9, color: '#9ca3af' }}>{test.register.split('T')[0]}</span>}
                        {test.creatorUsername && <span style={{ background: '#f5f3ff', color: '#7c3aed', padding: '0px 5px', borderRadius: 3, fontSize: 9, fontWeight: 600, border: '1px solid #ddd6fe' }}>@{test.creatorUsername}</span>}
                        {test.questions?.length > 0 && (
                          <span style={{ background: '#f0fdf4', color: '#16a34a', padding: '0px 5px', borderRadius: 3, fontSize: 9, fontWeight: 600, border: '1px solid #bbf7d0' }}>
                            {test.questions.length} sual
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '50px 16px', color: '#9ca3af', textAlign: 'center' }}>
              <i className="bi bi-clipboard2-check" style={{ fontSize: 30, marginBottom: 8, display: 'block', color: '#d1d5db' }}></i>
              <p style={{ fontSize: 11, fontWeight: 600, color: '#6b7280', margin: '0 0 4px' }}>Hələ ki test yoxdur</p>
              <p style={{ fontSize: 10, color: '#9ca3af', margin: 0 }}>Yeni test əlavə etmək üçün yuxarıdakı düyməni istifadə edin</p>
            </div>
          )}
        </div>
      </div>

      <ConfirmModal
        show={showDeleteConfirm}
        onHide={() => setShowDeleteConfirm(false)}
        onConfirm={handleDelete}
        title="Silməni Təsdiqlə"
        message={<><strong>{selectedTest?.name || selectedTest?.title}</strong> adlı testi silmək istədiyinizə əminsiniz?</>}
        confirmText="Bəli, Sil"
      />
      <ConfirmModal
        show={showCancelConfirm}
        onHide={() => setShowCancelConfirm(false)}
        onConfirm={confirmCancel}
        title="Ləğv etməyi təsdiqlə"
        message="Daxil edilmiş məlumatlar itiriləcək. Ləğv etmək istədiyinizə əminsiniz?"
        confirmText="Bəli, Ləğv et"
      />

      {imageModalSrc && (
        <div
          onClick={() => setImageModalSrc(null)}
          style={{
            position: 'fixed', inset: 0, zIndex: 10000,
            background: 'rgba(0,0,0,0.88)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <img
            src={imageModalSrc}
            alt=""
            onClick={e => e.stopPropagation()}
            style={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain', borderRadius: 8, boxShadow: '0 8px 40px rgba(0,0,0,0.4)' }}
          />
          <button
            onClick={() => setImageModalSrc(null)}
            style={{
              position: 'absolute', top: 16, right: 16,
              width: 36, height: 36, borderRadius: 8,
              background: 'rgba(255,255,255,0.15)', color: '#fff',
              border: '1px solid rgba(255,255,255,0.3)',
              cursor: 'pointer', fontSize: 18, fontWeight: 700,
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            }}
          >✕</button>
        </div>
      )}
      <ValidationErrorModal show={!!errorModal} onHide={clearError} message={errorModal?.message} validations={errorModal?.validations} />
    </>
  );
};

export default LectureTests;
